module.exports = __webpack_public_path__ + "static/media/mayur-about1.9192d353.jpg";